import { ReactNode, useMemo } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { PicklistValue } from '@rainbow-modules/listview/lib/components/AuditLogs/types';
import PicklistWithCustomOption from 'components/PicklistWithCustomOption';
import { Option } from 'react-rainbow-components';

interface PronounPickerProps {
    id?: string;
    className?: string;
    name?: string;
    label?: string;
    tabIndex?: number | string;
    placeholder?: string;
    error?: ReactNode;
    required?: boolean;
    value?: string | PicklistValue;
    onChange?: (value: PicklistValue) => void;
}

const options = [
    { name: 'he', label: 'He/Him', value: 'he' },
    { name: 'she', label: 'She/Her', value: 'she' },
    { name: 'they', label: 'They/Them', value: 'they' },
    { name: 'ze', label: 'Ze/Zir', value: 'ze' },
    { name: 'unknown', label: 'Prefer Not to Say', value: 'unknown' },
];

const PronounPicker = (props: PronounPickerProps) => {
    const {
        value: valueInProps,
        onChange = () => {},
        id,
        className,
        name,
        label,
        tabIndex,
        placeholder,
        error,
        required,
    } = useReduxForm(props);

    const pickListvalue = useMemo(() => {
        if (!valueInProps) return undefined;
        if (typeof valueInProps === 'string') {
            const found = options.find((option) => option.value === valueInProps);
            return found || { name: 'custom', label: 'Prefer to Self-Describe', value: valueInProps };
        }
        return valueInProps;
    }, [valueInProps]);

    const pickListOptions = useMemo(
        () => options.map((option) => <Option key={`pronoun-picker-option__${option.name}`} {...option} />),
        [],
    );

    return (
        <PicklistWithCustomOption
            id={id}
            name={name}
            className={className}
            label={label}
            tabIndex={tabIndex}
            required={required}
            placeholder={placeholder}
            value={pickListvalue}
            onChange={onChange}
            customOptionLabel="Prefer to Self-Describe"
            error={error}
        >
            <Option label="Pronoun" variant="header" />
            {pickListOptions}
        </PicklistWithCustomOption>
    );
};

export default PronounPicker;
